import { Grid, styled } from "@mui/material";
import React, { useRef } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

const Button = styled("button")`
  background: #1a1998;
  color: #fff;
  border: 1px solid #1a1998;
  font-size: 16px;
  padding: 15px;
`;

const ImageBox = styled(Grid)`
  width: 200px;
  height: 200px;
  border: 1px solid #afafaf;
  background: #afafaf;
  border-radius:10px;
`;

const CameraComponent = ({
  capturedImage,
  setCapturedImage,
  setImageBoxVisible,
  imageBoxVisible,
  setMediaStream,
  mediaStream,
  showCapture,
  setShowCapture,
}) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const openCamera = async () => {
    try {
      setImageBoxVisible(false);
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      });
      setShowCapture(true);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        setMediaStream(stream); // Store the stream in state
      } else {
        console.error("videoRef.current is null");
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  const captureImage = () => {
    if (videoRef.current && canvasRef.current) {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

      const imageDataURL = canvas.toDataURL("image/png");
      setCapturedImage(imageDataURL);
      videoRef.current = "";
      mediaStream.getTracks().forEach((track) => track.stop());
    }
  };

  const handleRecaptureImage = () => {
    setCapturedImage(null);
    openCamera();
  };

  return (
    <Grid container justifyContent={"center"} columnGap={2} height={250}>
      <Grid item>
        {imageBoxVisible && (
          <ImageBox
            alignItems={"center"}
            container
            direction={"row"}
            justifyContent={"center"}
            onClick={openCamera}
          >
            <CameraAltIcon fontSize="large" />
            Capture Image
          </ImageBox>
        )}
      </Grid>
      {capturedImage === null && (
        <Grid item container py={2} xs={12} justifyContent={"center"} >
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{ width: "250px", height: "150px" }}
          />
        </Grid>
      )}
      {!capturedImage && showCapture && (
        <Grid item container xs={12} justifyContent={"center"}>
          <Button type={"button"} onClick={captureImage}>
            Capture
          </Button>
        </Grid>
      )}
      <canvas ref={canvasRef} style={{ display: "none" }} />

      {capturedImage && (
        <Grid item container py={2} xs={12} justifyContent={"center"}>
          <img
            src={capturedImage}
            alt="Captured"
            style={{ maxWidth: "250px", borderRadius: '10px' }}
            height={'100px'}
          />
        </Grid>
      )}
      {capturedImage && (
        <Grid item>
          <Button type="button" onClick={handleRecaptureImage}>
            Recapture Image
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default CameraComponent;
